<template>
    <div id="timeAddress">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=4></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div class="flex flexstart">
                <div class="one">
                    <h2 class="">{{ h2Intro }}</h2>
                    <p v-html="details.open_time"></p>
                    <!-- <p>10:00- 18:00
                        周二至周日，除法定节假日外，周一闭馆。 <br/>
                        入馆截止至闭馆前30分钟。 <br/>
                        特展的开馆时间请另行确认。</p> -->
                </div>
                <div class="one">
                    <h2 class="">{{ h2Addr }}</h2>
                    <p v-html="details.addr"></p>
                    <!-- <p>北京市朝阳区酒仙桥北路9号恒通国际创新园C7号 <br/>
                        Tel: +010 6666 8888 <br/>
                        Fax: +010 6666 9999</p> -->
                </div>
                <img :src="details.map_image" alt="" class="map" v-show="isMobile == 'PC'">
            </div>
            <div class="flex flexstart">
                <div class="one longone">
                    <h2 class="">{{ h2Traffic }}</h2>
                    <p v-html="details.traffic_info"></p>
                    <!-- <p>乘坐公共交通工具来馆者:<br/>
                        乘坐地铁14号线，至望京南站下地铁，B1东北口出，步行1.5公里(约20分钟)到达<br/>
                        乘坐405路公交车，至大山子路口南站下车，步行500米(约8分钟)到达。<br/>
                        <br/>
                        驾车来馆者:<br/>
                        直接导航北京民生现代美术馆即可。<br/>
                        北京民生现代美术馆未设置停车场。</p> -->
                </div>
            </div>
            <img :src="details.map_image" alt="" class="map" v-show="isMobile == 'Mobile'">
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getTimaddr } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles, pageLabels,imageurl } from "../utils/i18nLabels";
    const isMobile = localStorage.getItem('userAgent')
    const details = ref({})
    const titleLabel = computed(() => backheadTitles.timeAddress[currentLanguage.value || 'zh'])
    const h2Intro = computed(() => pageLabels.timeAddress.intro[currentLanguage.value || 'zh'])
    const h2Addr = computed(() => pageLabels.timeAddress.addr[currentLanguage.value || 'zh'])
    const h2Traffic = computed(() => pageLabels.timeAddress.traffic[currentLanguage.value || 'zh'])
    // 获取数据
    function getList() {
        let queryParams = {
            category_id: 2
        }
        getTimaddr(queryParams).then(res => {
            const data = res.data
            data.open_time = currentLanguage.value == 'zh' ? data.open_time.replace(/\n/g, '<br>') : data.open_time_en.replace(/\n/g, '<br>')
            data.addr = currentLanguage.value == 'zh' ? data.addr.replace(/\n/g, '<br>') : data.addr_en.replace(/\n/g, '<br>')
            data.traffic_info = currentLanguage.value == 'zh' ? data.traffic_info.replace(/\n/g, '<br>') : data.traffic_info_en.replace(/\n/g, '<br>')
            data.map_image = data.map_image ? imageurl + data.map_image : undefined
            details.value = data;
        });
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #timeAddress{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        text-align: left;
        padding: 60px;
    }
    .flexstart{
        align-items: flex-start;
        margin-bottom: 30px;
    }
    .one{
        width: 30%;
    }
    .longone{
        width: 50%;
    }
    h2{
        font-size: 30px;
        color: #232323;
        margin-bottom: 30px;
        font-weight: normal;
    }
    p{
        color: #000;
        line-height: 30px
    }
    .map{
        width: 30%;
        margin: 10px 0;
    }
    
    .Mobileclass{
        margin-top: 160px;
        padding: 22px;
        .flex{
            display: block;
        }
        .one{
            margin-bottom: 60px;
        }
        .one, .longone, .map{
            width: 100%;
        }
        .map{
            display: block;
            margin: -30px 0 20px 0;
        }
    }
</style>